import { has } from 'lodash';

export default {
  namespaced: true,
  state: {
    itemDisplayType: window.innerWidth <= 768 ? 'list' : 'grid', // if user view from 768 or less then list else grid
    storeProfileRecord: {
      insertHistory: false,
      data: [],
    },
  },
  getters: {
    storeProfileRecord: state => state.storeProfileRecord,
    itemDisplayType: state => state.itemDisplayType,
  },
  mutations: {
    storeProfileRecordMutate(state, data) {
  
      if(data.insertHistory){
        state.storeProfileRecord.insertHistory = data.insertHistory;
      }
      if(data.data){
        state.storeProfileRecord.data = data.data;
      }
      // if(_.has(data, 'data')){
      //   state.storeProfileRecord.data = data.data;
      // }
    },
    itemDisplayTypeMutate(state, data) {
      state.itemDisplayType = data;
    }
  },
  actions: {
      setItemDisplayType(context, data) {
        context.commit('itemDisplayTypeMutate', data)
      },
      setStoreProfileRecord(context, data) {
        context.commit('storeProfileRecordMutate', data)
      }
  }
}